import { InjectionToken } from '@angular/core';

export const SERVICES_API = new InjectionToken<string>('SERVICES_API');
